import { ComponentProps, ReactNode } from "react";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Breadcrumbs } from "@filadd/phi-plus-core";

interface Props {
  title?: string;
  children?: ReactNode;
  showBreadcrumb?: boolean;
  crumb?: ComponentProps<typeof Breadcrumbs>["crumb"];
}

export const CommonLayout = ({
  title,
  showBreadcrumb = true,
  crumb,
  children,
}: Props) => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: 4,
        mb: 8,
      })}
    >
      {(showBreadcrumb || crumb) && <Breadcrumbs crumb={crumb} />}

      {title && (
        <h2
          className={css({
            textStyle: "titleLarge",
          })}
        >
          {title}
        </h2>
      )}

      {children}
    </div>
  );
};
